exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-password__input{height:81px}", ""]);

// exports
exports.locals = {
	"pwdClassName": "\"ba-common-password\""
};